// extracted by css-extract-rspack-plugin
export default {"root":"ptNlIu","spinnerWrapper":"haWFo3"};